<div class="menu-container">
  <ng-container *ngFor="let menuItem of menuItems; let i=index">
    <!-- Menu items-->
    <div>
      <!-- Left-hand side of menu keeps the icons of first level menu items -->
      <div class="menu-icons-background" [style.background]="i === activeItemIndex ? '#3D3B3B' : ''">
        <nb-icon
          class="menu-icons"
          *ngIf="menuItem.icon"
          [style.opacity]="i === activeItemIndex || i === hoveredIndex ? '1' : '0.5'"
          (click)="onIconClicked(i)"
          (mouseenter)="onMouseEnter(i)"
          (mouseleave)="onMouseLeave()"
          [icon]="menuItem.icon.icon"
          [pack]="menuItem.icon.pack">
        </nb-icon>
      </div>
      <!-- Right-hand side of menu keeps the menu items -->
      <div class="menu-items">
        <!-- For the first level of menu items, do not display the icons since they are displayed in the div above -->
        <uruk-menu-item [displayMenuItemIcon]="false" [menuItem]="menuItem" [menuIndex]="i" (clickedItemIndex)="onMenuItemClicked($event)">
        </uruk-menu-item>
      </div>
    </div>
  </ng-container>
</div>
